(function ($) {
  const $menu = $(".navbar-collapse");
  const $hamburger = $(".hamburger");

  $menu.on("show.bs.collapse", function () {
    $hamburger.addClass("is-active");
  });

  $menu.on("hide.bs.collapse", function () {
    $hamburger.removeClass("is-active");
  });
})(jQuery);
